/**
 * hotfix to reset the main column scroll back to 0
 * the scroll state sometimes gets changed when jumping to an anchor, but I couldn't figure out why
 * @param scope html scope, considered to be `document` when null
 */
function fixMainColScroll(scope) {
  if (scope === null || scope === undefined) {
    scope = document;
  }
  const mainCols = scope.querySelectorAll(".maincol");
  mainCols.forEach(mainCol => {
    mainCol.addEventListener("scroll", (event) => {
      console.info("[fixMainColScroll] resetting main column scroll position to 0", event.currentTarget);
      event.currentTarget.scrollTop = 0;
    });
  });
}

export default fixMainColScroll;
